import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentWord, setCurrentWord] = useState(0);
  const words = ['体育资讯', '赛事预测', '运动健康', '竞技热血'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentWord((prev) => (prev + 1) % words.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20with%20dramatic%20stadium%20lighting%2C%20athletic%20silhouettes%20in%20motion%2C%20epic%20sports%20atmosphere%20with%20warm%20golden%20and%20crimson%20tones%2C%20abstract%20motion%20blur%2C%20cinematic%20sports%20photography%2C%20dark%20dramatic%20background%20with%20light%20streaks&width=1920&height=1080&seq=kaiyun-hero-bg&orientation=landscape"
        alt="开运体育 - 体育竞技平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/60 via-foreground-900/40 to-foreground-900/70"></div>

      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-fire-fill text-accent-400"></i>
          <span className="text-background-50/90 text-sm font-medium">专业的体育竞技与赛事服务平台</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-4">
          开运体育
          <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl font-bold text-background-50/90">
            赢在每一场
          </span>
        </h1>

        <p className="text-background-50/70 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          开运体育涵盖<span className="text-accent-300 font-semibold">{words[currentWord]}</span>等全方位内容。
          加入开运体育，感受竞技热血，把握每一次运动机遇，开启您的幸运体育之旅。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/saishi-yuce"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            查看赛事预测
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-all whitespace-nowrap"
          >
            了解开运体育
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">500+</div>
            <div className="text-background-50/60 text-xs mt-1">赛事覆盖</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">200万+</div>
            <div className="text-background-50/60 text-xs mt-1">活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">98%</div>
            <div className="text-background-50/60 text-xs mt-1">用户好评</div>
          </div>
        </div>
      </div>
    </section>
  );
}